// Extracted from appconst.ts's `AppConsts.localization` to break a real
// circular import: appconst.ts imported { L, LCategory } from abpUtility.ts
// (used only inside helper-function bodies, never at module top level) while
// abpUtility.ts imported AppConsts from appconst.ts (used at module scope,
// `const { localization } = AppConsts`). The cycle was harmless at runtime
// here — Vite/CRA/webpack resolve it fine since neither side reads the
// other's binding before both modules finish evaluating — but this
// self-contained, dependency-free object is the only piece of AppConsts
// abpUtility.ts actually needs, so both files import it directly instead of
// abpUtility.ts importing the whole of AppConsts back from appconst.ts.
export const localizationConst = {
  defaultLocalizationSourceName: "WebLabel",
  sourceWebNotification: "WebNotification",
  sourceWebError: "WebError",
  sourceWebMainMenu: "WebMainMenu",
  sourceWebCategory: "WebCategory",
}
